<!-- 
export interface LoyaltyAppMessageModel 
        Id?: number; // int32
        DisplayOrder?: number; // int32
        Title?: string;
        Text?: string;
        Url?: string;
        UrlDescrption?: string;
        UrlPlacement?: 1 | 2; // int32

 -->
<div class="tile-for-loyalty-message" [ngClass]="{'-inverted': inverted}">
    <div class="tile-for-loyalty-message__title" *ngIf="message?.Title">{{message.Title}}:</div>
    <div class="tile-for-loyalty-message__desc" *ngIf="message?.Text">{{message.Text}}</div>
    <div class="tile-for-loyalty-message__more" *ngIf="message?.Url">
        <shared-link (onClick)="handleLinkClick($event)" [inverted]="inverted" size="initial" [emphasis]="false"
            class="tile-for-loyalty-message__link" [title]="message.UrlDescrption || message.Url">
            {{message.UrlDescrption || message.Url}}
        </shared-link>
    </div>
</div>